import React from 'react';
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { Container, Row, Col } from 'react-bootstrap';
import { PROD } from '../../common/constants';
import { userDataScrutiny } from './Registration-Incharge/registrationInchargeHomePage';

function Scrutiny() {
    const navigate = useNavigate();
    const pendingAppCount = userDataScrutiny?.applicationStatusCount?.[0]?.count;
    const pendingClarificationsCount = userDataScrutiny?.applicationStatusCount?.[2]?.count;
    const pendingRejectionsCount = userDataScrutiny?.applicationStatusCount?.[1]?.count;
    const pendingResourceUpdateCount = userDataScrutiny?.applicationStatusCount?.[3]?.count;
    const pendingResourceUpdateClarificationCount = userDataScrutiny?.applicationStatusCount?.[4]?.count;
    const userId = userDataScrutiny?.user?.id;
    const backScrutiny = true;
    function viewAllPendingApplications(e, resourceUpdate) {
        e.preventDefault();
        navigate("/registrationHome/scrutiny/viewAllAssignedStakeholders", { state: { userid: userId, backScrutiny: backScrutiny, isResourceUpdate: resourceUpdate } });
    }
    function viewAllClarifications(e, resourceUpdate) {
        e.preventDefault();
        navigate("/registrationHome/scrutiny/viewAllClarifications", { state: { userid: userId, backScrutiny: backScrutiny, isResourceUpdate: resourceUpdate } });
    }
    function viewAllPendingRejections(e, resourceUpdate) {
        e.preventDefault();
        navigate("/registrationHome/scrutiny/viewAllPendingRejections", { state: { userid: userId, backScrutiny: backScrutiny, isResourceUpdate: resourceUpdate } });
    }

function viewSendToSAP(e) {
    e.preventDefault();
    navigate("/registrationHome/scrutiny/sendToSAP", {
      state: { userid: userId, backScrutiny: backScrutiny }
    });
  }

    return (

        <div className="Home-page">
            <div>
                <Container fluid>
                    <Row>
                        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG39</p>}
                        <Col xs={6} md={4}>
                            <div className="onboarded-card">
                                <a href='#' onClick={(e) => viewAllPendingApplications(e, '')} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                                <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingAppCount}</Typography>
                                <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Approvals</Typography>
                            </div>
                        </Col>
                        <Col xs={6} md={4}>
                            <div className="onboarded-card">
                                <a href='#' onClick={(e) => viewAllPendingRejections(e, '')} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                                <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingRejectionsCount}</Typography>
                                <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Rejections</Typography>
                            </div>
                        </Col>
                        <Col xs={6} md={4}>
                            <div className="onboarded-card">
                                <a href='#' onClick={(e) => viewAllClarifications(e, '')} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                                <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingClarificationsCount}</Typography>
                                <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Clarifications</Typography>
                            </div>
                        </Col>
                        <Col xs={6} md={4}>
                            <div className="onboarded-card">
                                <a href='#' onClick={(e) => viewAllPendingApplications(e, 'ResourceUpdate')} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                                <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingResourceUpdateCount}</Typography>
                                <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Resource Update</Typography>
                            </div>
                        </Col>
                        <Col xs={6} md={4}>
                            <div className="onboarded-card">
                                <a href='#' onClick={(e) => viewAllPendingApplications(e, 'ResourceUpdate')} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                                <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingResourceUpdateClarificationCount}</Typography>
                                <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Resource Update Clarifications</Typography>
                            </div>
                        </Col>
                        <Col xs={6} md={4} >
                            <div className="onboarded-card">
                                <a
                                    href="#"
                                    onClick={(e) => viewSendToSAP(e)}
                                    style={{
                                        color: '#005BAA',
                                        marginLeft: '16vw',
                                        marginTop: '0vh',
                                        position: 'absolute'
                                    }}
                                >
                                    View all
                                </a>

                                <Typography
                                    style={{
                                        fontWeight: 500,
                                        color: '#000000',
                                        fontSize: '1rem',
                                        textAlign: 'left',
                                        marginTop: '9vh'
                                    }}
                                >
                                    Send to SAP
                                </Typography>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}

export default Scrutiny;